module.exports = __webpack_public_path__ + "img/eyes_female_extra_round.d2154cf7.png";